import Vue from 'vue';
import Vuex from 'vuex';
// import axios from 'axios';
var jwt = require('jsonwebtoken');
import * as moment from 'moment';
import router from '../router/router';
import { compareVersions } from '../utilities/version';
import { sortAlphabetical } from '../utilities/setTheory';

Vue.use(Vuex);

Vue.axios.defaults.baseURL = process.env.VUE_APP_API;

let store = new Vuex.Store({
    state: {
        token: localStorage.getItem('user-token') || '',
        username: '',
        userId: '',
        project: '',
        rights: null,
        snackbar: {
            show: false,
            text: "",
            timeout: 3500,
            color: "success"
        },
        version: undefined,
        versionOk: undefined,
        files: [],
        showAppBar: true,
        showNavDrawer: true
    },
    getters: {
        showAppBar: function (state) {
            return state.showAppBar;
        },
        showNavDrawer: function (state) {
            return state.showNavDrawer;
        },
        isAuthenticated: (state) => {
            try {
                var t = jwt.decode(state.token);
                // TODO: check expiration date
                if (!t || t.exp < moment().unix()) {
                    state.token = '';
                    localStorage.removeItem('user-token');
                    state.username = '';
                    state.userId = '';
                    state.project = '';
                    state.rights = null;
                    return false;
                }

                return true;
            }
            catch (err) {
                return false;
            }
        },
        token: function (state) {
            return state.token;
        },
        project: function (state) {
            return state.project;
        },
        username: function (state) {
            return state.username;
        },
        userId: function (state) {
            return state.userId;
        },
        rights: function (state) {
            return state.rights;
        },
        snackbar: function (state) {
            return state.snackbar;
        },
        version: function (state) {
            return state.version;
        },
        versionOk: function (state) {
            return state.versionOk;
        },
        filesByType: (state) => (fileType) => {
            if (fileType && fileType.length > 0) {
                return state.files.filter(file => {
                    let regex = /(.*)\/(.*)\/(.+)/;
                    let result = regex.exec(file.name);
                    return result && result[2] === fileType;
                }).sort(sortAlphabetical("name"));
            }

            return state.files;
        },
        file: (state) => (fileName) => {
            let index = state.files.findIndex(f => f.name === fileName);
            if (index === -1) {
                return undefined;
            }
            return state.files[index];
        },
        files: function (state) {
            return state.files.sort(sortAlphabetical("name"));
        }
    },
    mutations: {
        showAppBar: function (state, show) {
            state.showAppBar = show;
        },
        showNavDrawer: function (state, show) {
            state.showNavDrawer = show;
        },
        login: function (state, token) {
            state.token = token;
            localStorage.setItem('user-token', token);
            Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('user-token')}`;
        },
        project: function (state, project) {
            state.project = project;
            // axios.defaults.baseURL = `http://${project}.proxylock.com:8088/`;
            // axios.defaults.baseURL = `http://${project}.localhost:8088/`;

            // axios.defaults.baseURL = process.env.VUE_APP_API.replace('#', project);

            Vue.axios.defaults.baseURL = process.env.VUE_APP_API;
            Vue.axios.defaults.params = {};
            Vue.axios.defaults.params['project'] = project;

            // console.log(project);
            // console.log(Vue.axios.defaults.baseURL);
            // console.log(process.env.VUE_APP_API);
            // console.log(project);
        },
        username: function (state, username) {
            state.username = username;
        },
        userId: function (state, userId) {
            state.userId = userId;
        },
        rights: function (state, rights) {
            state.rights = rights;
        },
        logout: function (state) {
            localStorage.removeItem('user-token');
            state.token = null;
            delete Vue.axios.defaults.headers.common['Authorization'];
            state.files.splice(0);
        },
        snackbar: function (state, snackbar) {
            state.snackbar = snackbar;
        },
        version: function (state, version) {
            state.version = version;
        },
        versionOk: function (state, versionOk) {
            state.versionOk = versionOk;
        },
        addFile: function (state, file) {
            if (state.files.findIndex(f => f.name === file.name) <= 0) {
                state.files.push(file);
                state.files.sort(sortAlphabetical("name"));
            }
        },
        removeFile: function (state, file) {
            let index = state.files.findIndex(f => f.name === file.name);
            if (index >= 0) {
                state.files.splice(index, 1);
            }
        }
    },
    actions: {
        login: function (context, loginDetails) {
            // console.log(`axios base url = ${Vue.axios.defaults.baseURL}`);
            return Vue.axios.post('/auth', loginDetails)
                .then(response => {
                    const token = response.data.token;

                    return context.dispatch("token", token);
                })
                .catch(err => {
                    localStorage.removeItem('user-token');
                    return { success: false, message: err.message };
                });
        },
        token: function (context, token) {
            return new Promise((resolve, reject) => {
                if (!token) {
                    // todo
                }
                else {
                    try {
                        let t = jwt.decode(token);

                        if (!t) {
                            context.commit('logout')
                            reject({ success: false, message: "token invalid" });
                            return;
                        }

                        if (!!t && t.exp < moment().unix()) {
                            resolve({ success: false, message: "token expired" });
                            return;
                        }

                        context.commit('login', token);
                        context.commit('project', t.project);
                        context.commit('username', t.username);
                        context.commit('userId', t.id);
                        context.commit('rights', t.rights);

                        resolve({ success: true, message: "authorized", project: t.project });
                    }
                    catch (err) {
                        reject({ success: false, message: err.message });
                    }
                }



                // if (!token) {
                //     context.commit('logout')
                //     reject({ success: false, message: "no token" });
                // }
                // else {
                //     try {
                //         let t = jwt.decode(token);

                //         if (!t) {
                //             context.commit('logout')
                //             reject({ success: false, message: "token invalid" });
                //             return;
                //         }

                //         if (!!t && t.exp < moment().unix()) {
                //             resolve({ success: false, message: "token expired" });
                //             return;
                //         }

                //         context.commit('login', token);
                //         context.commit('project', t.project);
                //         context.commit('username', t.username);
                //         context.commit('userId', t.id);
                //         context.commit('rights', t.rights);

                //         resolve({ success: true, message: "authorized", project: t.project });
                //     }
                //     catch (err) {
                //         reject({ success: false, message: err.message });
                //     }
                // }
            });

        },
        logout: function (context) {
            return new Promise((resolve) => {
                context.commit('logout');
                context.commit('username', null);
                context.commit('userId', null);
                context.commit('project', null);
                context.commit('rights', null);
                resolve(true);
            });

        },
        snackbar: function (context, snackbar) {
            return new Promise(resolve => {
                context.commit("snackbar", snackbar);
                resolve();
            });
        },
        isVersionOk: async function (context) {
            try {
                let serverVersion = (await Vue.axios.get("/version?type=frontend")).data.version;

                let getters = context.getters;
                let localVersion = getters.version;

                if (!localVersion) {
                    if (serverVersion) {
                        context.commit("version", serverVersion);
                    }

                    context.commit("versionOk", true);
                    return Promise.resolve(true);
                }

                if (compareVersions(localVersion, serverVersion) < 0) {
                    context.commit("versionOk", false);
                    return Promise.resolve(false);
                }
                else {
                    context.commit("versionOk", true);
                    return Promise.resolve(true);
                }

                // debugger;
                // context.commit("version", version.version);

                // if(compareVersions(context.getters.version, version.version) < 0){
                //     context.commit("versionOk", false);
                //     debugger;

                //     return Promise.resolve(false);
                // }
                // else{
                //     context.commit("versionOk", true);
                //     debugger;

                //     return Promise.resolve(true);
                // }

            } catch (error) {

                context.commit("versionOk", true);
                return Promise.resolve(true);
            }
        },
        downloadFile: async function (context, fileName) {
            let response = await Vue.axios.post(
                `/content/dl`,
                {
                    file: fileName
                },
                {
                    responseType: "arraybuffer"
                }
            );

            let binary = response.data;
            let buffer = Buffer.from(binary, "binary").toString("base64");
            let src = `data:${response.headers["content-type"]};base64, ${buffer}`;

            let blob = new Blob([Buffer.from(binary, "binary")], { type: response.headers["content-type"] });
            let url = URL.createObjectURL(blob);

            return { binary, buffer, src, blob, url };
        },
        uploadFile: async function (context, { file, fileType }) {
            if (!file || !fileType) {
                context.dispatch("snackbar", { show: true, text: "Mangler fil og/eller filtype", color: "error" })
                return Promise.reject(`File and/or file type ${file.name} missing.`);
            }
            // check size
            if (file.size > 3 * 1024 * 1024) {
                context.dispatch("snackbar", { show: true, text: "Maks filstørrelse er 3MB", color: "error" })
                return Promise.reject(`Maks filstørrelse er 3MB.`);
            }

            let formData = new FormData();
            formData.append("file", file);

            let requestConfig = {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            };

            try {
                let response = await Vue.axios.post(
                    `/content/${fileType}/${file.name}`,
                    formData,
                    requestConfig
                )

                return { fileName: response.data.name, fileSize: response.data.size }
            }
            catch (err) {
                context.dispatch("snackbar", { show: true, text: "opplast mislykket", color: "error" });
                return Promise.reject(`Upload error file ${file.name}.`);
            }
        },
        deleteFile: async function (context, file) {
            try {
                await Vue.axios.delete("/content", { data: { file: file.name } });
                return;
            }
            catch {
                context.dispatch("snackbar", { show: true, text: "slett mislykket", color: "error" });
                return Promise.reject(`Delete error file ${file.name}.`)
            }
        },
        listFiles: async function (context, fileType) {
            try {
                let response = await Vue.axios.get("/content");

                let files = response.data;

                // if (fileType && fileType.length > 0) {
                files = files.filter(file => {
                    let regex = /(.*)\/(.*)\/(.+)/;
                    let result = regex.exec(file.name);
                    if (result) {
                        if (!fileType) return true;

                        return result && result[2] === fileType;
                    }
                    return false;
                });
                // }

                // response.data.forEach(file => {
                //     context.commit("addFile", file);
                // });

                return files.sort(sortAlphabetical("name"));

            } catch (error) {
                context.dispatch("snackbar", { show: true, text: "filhenting mislykket", color: "error" });
                return Promise.reject(`File fetching error.`)
            }
        },
        hasFile: function (context, file) {
            return context.state.files.findIndex(f => f.name === file.name) >= 0;
        },
        addFile: function (context, file) {
            return new Promise(async (resolve) => {
                let hasFile = await context.dispatch("hasFile", file);
                if (!hasFile) {
                    context.commit("addFile", file);
                    resolve(true);
                    return;
                }
                else {
                    // if the object is already in the store then update the file
                    // Object.assign(context.getters.file(file.name), file);

                    let target = context.getters.file(file.name);

                    for (const key in file) {
                        if (file.hasOwnProperty(key)) {
                            const value = file[key];
                            Vue.set(target, key, value);
                        }
                    }

                }
                resolve(false);
                return;
            });
        },
        removeFile: function (context, file) {
            return new Promise(async (resolve) => {
                let hasFile = await context.dispatch("hasFile", file);
                if (hasFile) {
                    context.commit("removeFile", file);
                    resolve(true);
                    return;
                }

                resolve(false);
                return;
            });
        },
        clearFiles: function (context) {
            context.state.files.splice(0);
        }
    }
});


store.dispatch('token', localStorage.getItem('user-token')).then(obj => {
    if (obj == false) {
        router.push({ path: '/login' });
    }
}).catch(() => {
    router.push({ path: '/login' });
});

export default store;